import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import api from "./../api";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    hydrants: [],
    hydrantChecks: [],
    pumpOperators: [],
    apparatus: [],
    flashV2: {},
    currentPosition: {},
    showLocation: false,
    showMuniHydrantsV2: false
  },
  getters: {
    hydrantCount: state => state.hydrants.length,
    pumpOperatorName: (state, pumpOperatorId) => {
      return state.pumpOperators.find(pumpOperator => {
        if (pumpOperatorId === pumpOperator.id) {
          return pumpOperator.name;
        }
      });
    }
  },
  mutations: {
    setEverything(state, items) {
      state.hydrants = items.hydrants;
      state.hydrantChecks = items.hydrant_checks;
      state.pumpOperators = items.pump_operators;
      state.apparatus = items.apparatus;
    },
    addHydrantCheck(state, hydrantCheck) {
      state.hydrantChecks.push(hydrantCheck);
    },
    setFlash(state, flash) {
      state.flashV2 = flash;
    },
    toggleShowLocation(state) {
      state.showLocation = !state.showLocation;
    },
    toggleShowMuniHydrants(state) {
      state.showMuniHydrantsV2 = !state.showMuniHydrants;
    },
    setCurrentPosition(state, newPosition) {
      state.currentPosition = newPosition;
    }
  },
  actions: {
    getEverything({ commit }) {
      api.getEverything().then(response => {
        commit("setEverything", response.data);
      });
    },
    setFlash({ commit }, flash) {
      commit("setFlash", flash);
    },
    async createHydrantCheck({ commit }, hydrant) {
      await api.createHydrantCheck(hydrant).then(response => {
        return this.dispatch("setFlash", response.data.flash).then(() => {
          commit("addHydrantCheck", response.data.hydrant_check);
        });
      });
    },
    toggleShowLocation({ commit }) {
      commit("toggleShowLocation");
    },
    toggleShowMuniHydrants({ commit }) {
      commit("toggleShowMuniHydrants");
    },
    setCurrentPosition({ commit }, newPosition) {
      commit("setCurrentPosition", newPosition);
    }
  },
  modules: {}
});
